var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.813,
    height: 24.929,
    viewBox: "0 0 21.813 24.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-file-picture",
    "data-name": "Icon metro-file-picture",
    d: "M23.2,23.741H7.615V20.625l4.674-7.79,6.4,7.79,4.5-3.116Zm0-10.128a2.337,2.337,0,1,1-2.337-2.337A2.337,2.337,0,0,1,23.2,13.614ZM25.285,7.5a22.075,22.075,0,0,0-2.122-2.427,22.08,22.08,0,0,0-2.427-2.122,3.883,3.883,0,0,0-2.214-1.027H6.446A1.95,1.95,0,0,0,4.5,3.876V24.91a1.95,1.95,0,0,0,1.948,1.948H24.364a1.95,1.95,0,0,0,1.948-1.948V9.718A3.883,3.883,0,0,0,25.285,7.5ZM22.061,6.179A21.249,21.249,0,0,1,23.828,8.16H20.08V4.413a21.228,21.228,0,0,1,1.981,1.767Zm2.693,18.73a.4.4,0,0,1-.39.39H6.446a.4.4,0,0,1-.39-.39V3.876a.4.4,0,0,1,.39-.39H18.521V8.939a.779.779,0,0,0,.779.779h5.453Z",
    transform: "translate(-4.499 -1.928)",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePicture);
export default __webpack_public_path__ + "static/media/file-picture.24fb7ea892c709e1c4db004c8c69757c.svg";
export { ForwardRef as ReactComponent };